import React, { MouseEvent } from 'react';

export function ToggleButtonGroup({
  value,
  onChange,
  children,
  className,
  'aria-label': ariaLabel,
  style,
}: {
  value: string;
  exclusive?: boolean;
  onChange: (event: MouseEvent<HTMLDivElement>, newValue: string) => void;
  children: React.ReactNode;
  className?: string;
  'aria-label'?: string;
  style?: React.CSSProperties;
}): JSX.Element {
  return (
    <div
      className={`custom-toggle-button-group ${className || ''}`}
      style={style}
      role="group"
      aria-label={ariaLabel}
    >
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as React.ReactElement<any>, {
            isSelected: child.props.value === value,
            onClick: (e: MouseEvent<HTMLButtonElement>) => {
              onChange(e as unknown as MouseEvent<HTMLDivElement>, child.props.value);
            },
          });
        }
        return child;
      })}
      <style jsx>{`
        .custom-toggle-button-group {
          display: inline-flex;
          border-radius: 4px;
          border: 1px solid #c4c4c4;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
}

export function ToggleButton({
  isSelected,
  onClick,
  children,
  className,
  style,
}: {
  value: string;
  isSelected?: boolean;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}): JSX.Element {
  return (
    <button
      type="button"
      className={`custom-toggle-button ${isSelected ? 'selected' : ''} ${className || ''}`}
      style={style}
      onClick={onClick}
    >
      {children}
      <style jsx>{`
        .custom-toggle-button {
          padding: 4px 11px;
          border: none;
          background-color: white;
          transition: background-color 0.2s, color 0.2s;
          cursor: pointer;
          font-family: inherit;
        }
        .custom-toggle-button:not(:last-child) {
          border-right: 1px solid #c4c4c4;
        }
        .custom-toggle-button.selected {
          background-color: rgba(0, 0, 0, 0.08);
          color: black;
        }
        .custom-toggle-button:hover {
          background-color: ${isSelected ? 'rgba(0, 0, 0, 0.12)' : 'rgba(0, 0, 0, 0.04)'};
        }
      `}</style>
    </button>
  );
}
